import type { HelpFile } from '../../types/help'
import { AnnouncerTestIds } from '../../../testids/AnnouncerTestIds'

export const announcerHelp: HelpFile = {
  texts: {
    [AnnouncerTestIds.announcerLiveRegion]: null,
  },
}
